<div [formGroup]="escopoForm" class="pt-3">
    <div class="section-container">
        <div class="section-title">
            <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
            <span>Produto</span>
        </div>

        <div class="sub-section-container">
            <div class="sub-section-title"><mat-icon class="material-symbols-outlined">inventory_2</mat-icon><span>Produto</span></div>
            <div class="escopo-input-row">
                <div class="escopo-input-field">
                    <app-select-pesquisavel [control]="produtoControl" label="Pesquisar produto" [apiUrl]="produtoLookupUrl"
                        idField="idProduto" nameField="descricao" [isOptional]="true" subscriptSizing="dynamic"
                        (selectionChange)="onProdutoSelecionado($event)">
                    </app-select-pesquisavel>
                </div>
                <button mat-flat-button class="btn-primary btn-add-valor" type="button" [disabled]="!produtoSelecionado" (click)="adicionarProduto()"><mat-icon>add</mat-icon>Adicionar</button>
            </div>
            @if (produtos.length > 0) {
            <div class="status-badge-grid mt-2">
                @for (produto of produtos; track produto.codigo) {
                <span class="status-badge badge-cinza">{{ badgeLabel(produto) }}<button type="button" class="badge-close-btn" (click)="removerProduto(produto)"><mat-icon>close</mat-icon></button></span>
                }
            </div>
            } @else {
            <app-empty-state icon="inventory_2" title="Nenhum produto adicionado" subtitle="Sem seleção, a regra vale para qualquer produto."></app-empty-state>
            }
        </div>

        <div class="sub-section-container">
            <div class="sub-section-title"><mat-icon class="material-symbols-outlined">category</mat-icon><span>NCM</span></div>
            <div class="escopo-input-row">
                <mat-form-field appearance="outline" class="escopo-input-field" subscriptSizing="dynamic">
                    <mat-label>NCM</mat-label>
                    <input matInput type="text" inputmode="numeric" [(ngModel)]="ncmValor" [ngModelOptions]="{ standalone: true }" [mask]="masks.ncm"
                        placeholder="Ex: 0101.21.00, 0101" (keydown)="onNcmKeydown($event)" (keydown.enter)="adicionarNcmManual()">
                    <button mat-icon-button matSuffix type="button" matTooltip="Pesquisar NCM" (click)="pesquisarNcm()"><mat-icon>search</mat-icon></button>
                </mat-form-field>
                <button mat-flat-button class="btn-primary btn-add-valor" type="button" [disabled]="![2,4,5,6,7,8].includes((ncmValor || '').replace(/\D/g,'').length)" (click)="adicionarNcmManual()"><mat-icon>add</mat-icon>Adicionar</button>
            </div>
            @if (ncms.length > 0) {
            <div class="status-badge-grid mt-2">
                @for (ncm of ncms; track ncm) {
                <span class="status-badge badge-cinza">{{ formatNcm(ncm) }}<button type="button" class="badge-close-btn" (click)="removerNcm(ncm)"><mat-icon>close</mat-icon></button></span>
                }
            </div>
            } @else {
            <app-empty-state icon="category" title="Nenhum NCM adicionado" subtitle="Sem seleção, a regra vale para qualquer NCM."></app-empty-state>
            }
        </div>
    </div>

    <div class="section-container">
        <div class="section-title">
            <mat-icon class="material-symbols-outlined">person_search</mat-icon>
            <span>Cliente</span>
        </div>

        <div class="row g-3">
            <div class="col-12 col-lg-4">
                <div class="sub-section-container">
                    <div class="sub-section-title">
                        <mat-icon class="material-symbols-outlined">person_search</mat-icon>
                        <span>Contribuinte de IBS/CBS</span>
                    </div>
                <app-select-pesquisavel
                    [control]="$any(escopoForm.get('contribIbsCbs'))"
                    label="Contribuinte de IBS/CBS"
                    [offlineList]="contribIbsCbsOptions"
                    idField="id"
                    nameField="descricao"
                    [multiple]="true"
                    subscriptSizing="dynamic"
                    [isOptional]="true">
                </app-select-pesquisavel>
                @if (escopoSelecionados('contribIbsCbs', contribIbsCbsOptions).length > 0) {
                <div class="status-badge-grid mt-2">
                    @for (b of escopoSelecionados('contribIbsCbs', contribIbsCbsOptions); track b.id) {
                    <span class="status-badge badge-cinza">
                        {{ b.label }}
                        <button type="button" class="badge-close-btn" (click)="removerEscopoSelecionado('contribIbsCbs', b.id)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </span>
                    }
                </div>
                } @else {
                <app-empty-state icon="person_search" title="Nenhum contribuinte de IBS/CBS selecionado" subtitle="Sem seleção, a regra vale para qualquer cliente."></app-empty-state>
                }
                </div>
            </div>

            <div class="col-12 col-lg-4">
                <div class="sub-section-container">
                    <div class="sub-section-title">
                        <mat-icon class="material-symbols-outlined">account_balance</mat-icon>
                        <span>Regime Tributário</span>
                    </div>
                <app-select-pesquisavel
                    [control]="$any(escopoForm.get('regimesTrib'))"
                    label="Regime Tributário"
                    [offlineList]="listaRegimeTributario"
                    idField="id"
                    nameField="descricao"
                    [multiple]="true"
                    subscriptSizing="dynamic"
                    [isOptional]="true">
                </app-select-pesquisavel>
                @if (escopoSelecionados('regimesTrib', listaRegimeTributario).length > 0) {
                <div class="status-badge-grid mt-2">
                    @for (b of escopoSelecionados('regimesTrib', listaRegimeTributario); track b.id) {
                    <span class="status-badge badge-cinza">
                        {{ b.label }}
                        <button type="button" class="badge-close-btn" (click)="removerEscopoSelecionado('regimesTrib', b.id)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </span>
                    }
                </div>
                } @else {
                <app-empty-state icon="account_balance" title="Nenhum regime tributário selecionado" subtitle="Sem seleção, a regra vale para qualquer cliente."></app-empty-state>
                }
                </div>
            </div>

            <div class="col-12 col-lg-4">
                <div class="sub-section-container">
                    <div class="sub-section-title">
                        <mat-icon class="material-symbols-outlined">badge</mat-icon>
                        <span>Tipo Tributário</span>
                    </div>
                <app-select-pesquisavel
                    [control]="$any(escopoForm.get('tiposTrib'))"
                    label="Tipo Tributário"
                    [offlineList]="listaTipoTributario"
                    idField="id"
                    nameField="descricao"
                    [multiple]="true"
                    subscriptSizing="dynamic"
                    [isOptional]="true">
                </app-select-pesquisavel>
                @if (escopoSelecionados('tiposTrib', listaTipoTributario).length > 0) {
                <div class="status-badge-grid mt-2">
                    @for (b of escopoSelecionados('tiposTrib', listaTipoTributario); track b.id) {
                    <span class="status-badge badge-cinza">
                        {{ b.label }}
                        <button type="button" class="badge-close-btn" (click)="removerEscopoSelecionado('tiposTrib', b.id)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </span>
                    }
                </div>
                } @else {
                <app-empty-state icon="badge" title="Nenhum tipo tributário selecionado" subtitle="Sem seleção, a regra vale para qualquer cliente."></app-empty-state>
                }
                </div>
            </div>
        </div>
    </div>
</div>
